// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-tabview .p-tabview-panels {
  background-color: transparent;
}

:host ::ng-deep .p-tabview-nav-content {
  text-align: center;
}

:host ::ng-deep .p-tabview-nav {
  min-width: auto;
}

:host ::ng-deep .p-tabview-nav .tab-counter {
  color: white;
  padding: 0.125rem 0.5rem;
  font-size: 0.875rem;
}

:host ::ng-deep .p-tabview-nav .p-highlight .tab-counter {
  background-color: #00a5cf;
}

:host ::ng-deep .p-tabview-nav .tab-counter {
  background-color: #dee2e6;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
